const validate = value => {
  if (value === null || value === '') {
    return false
  }
  return true
}

export default {
  validate,
  getMessage: (field, args) => {
    return 'Please tick the box "I am not a robot"'
  }
}
